import React from 'react';

const BackgroundImage = ({ src, style, className, children }) => {
  return (
    <div
      className={className}
      style={{
        position: 'relative', // Keeps the background and content grouped
        width: '100%', // Container spans full width
        ...style, // Allow additional custom styles
      }}
    >
      {/* Background Image */}
      <img
        src={src}
        alt="Background"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '140vh',
          objectFit: 'fill',
          zIndex: -1,
          pointerEvents: 'none',
        }}
      />
      {/* Dark overlay to deepen the gradient */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '140vh',
          backgroundColor: 'rgba(0, 0, 0, 0.35)',
          zIndex: -1,
          pointerEvents: 'none',
        }}
      />
      {/* Content */}
      <div
        style={{
          position: 'relative', // Ensures content is above the image
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default BackgroundImage;
